import React, { useMemo } from 'react';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import { IBigRiserTableProps, IEntityType } from '../../typings';
import SvgIcon from '@/pages/home/components/SvgIcon';
import DynamicTable from './Table';
import { useIntl, getLocale } from 'umi';
export default function DynamicColTableWrap(props: IBigRiserTableProps) {
  const {
    tableType = '',
    title,
    tableData,
    date,
    total,
    keyMap,
    isLoading = false,
    entityType,
    isTitleCanBeClick,
    ratioHideCol = [],
    metricCol = [],
    firstCol,
    infoCol = [],
    specialCol = [],
    titleAdditionalIcon,
    tableSelected,
    tableSelectedAll,
    onPagingChange,
    onSortChange,
    getTextBubble,
    getIsHideCol,
    onModuleIconClick,
    onGameItemClick,
    onTableCheckboxChange,
    scrollMinWidth,
  } = props;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const getNoDataText = useMemo(() => {
    if (['newRelease', 'upcoming'].includes(tableType)) {
      return locale === 'zh-CN' ? `${title} 开发中。` : `We're working on the ${title} page.`;
    }
    return formatMessage({ id: 'common_nodata' });
  }, [tableType, locale]);
  return (
    <CardSlot
      className="dbi-insights-page-card"
      title={
        <div className="insights-gamehead">
          <div
            className={`insights-gamehead-title ${isTitleCanBeClick && 'canclick'}`}
            onClick={() => {
              if (onModuleIconClick instanceof Function) {
                onModuleIconClick(title);
              }
            }}
          >
            <span>{title}</span>
            {titleAdditionalIcon ? (
              <SvgIcon className="insights-gamehead-icon" type={titleAdditionalIcon} />
            ) : null}
          </div>
          <div className="insights-gamehead-text">{date}</div>
        </div>
      }
      iconList={[]}
    >
      <DynamicTable
        nodataMsg={getNoDataText}
        isDetail={true}
        isLoading={isLoading}
        tableData={tableData}
        keyMap={keyMap}
        total={total}
        entityType={entityType}
        tableSelected={tableSelected}
        tableSelectedAll={tableSelectedAll}
        ratioHideCol={ratioHideCol}
        metricCol={metricCol}
        firstCol={firstCol}
        infoCol={infoCol}
        specialCol={specialCol}
        onPagingChange={onPagingChange}
        onSortChange={onSortChange}
        getTextBubble={getTextBubble}
        getIsHideCol={getIsHideCol}
        onGameItemClick={onGameItemClick}
        onTableCheckboxChange={onTableCheckboxChange}
        scrollMinWidth={scrollMinWidth}
      />
    </CardSlot>
  );
}
